import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { getAllLocations, createLocation } from '../../features/locationsManagement/services/locationsManagementService';

const LocationsManagementPage = () => {
  const [locations, setLocations] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newLocationName, setNewLocationName] = useState('');

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = async () => {
    try {
      const data = await getAllLocations();
      setLocations(data);
    } catch (error) {
      console.error('Error fetching locations:', error.message);
    }
  };

  const handleDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => {
    setDialogOpen(false);
    setNewLocationName('');
  };

  const handleInputChange = (e) => setNewLocationName(e.target.value);

  const saveLocation = async () => {
    if (!newLocationName.trim()) {
      alert('Location name cannot be empty.');
      return;
    }
    try {
      await createLocation({ name: newLocationName });
      await fetchLocations();
      handleDialogClose();
    } catch (error) {
      console.error('Error creating location:', error.message);
    }
  };

  return (
    <Box sx={{ padding: '20px', maxWidth: '1200px', margin: 'auto' }}>
      <Stack direction="column" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Locations Management</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleDialogOpen}>
          Create New Location
        </Button>
      </Stack>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {locations.map((location) => (
              <TableRow key={location.id}>
                <TableCell>{location.id}</TableCell>
                <TableCell>{location.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle>Create New Location</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Location Name"
            value={newLocationName}
            onChange={handleInputChange}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button variant="contained" onClick={saveLocation}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LocationsManagementPage;
